
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nova/creators-leaderboard",
      function () {
        return require("private-next-pages/nova/creators-leaderboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nova/creators-leaderboard"])
      });
    }
  